import React, { useState, useEffect, useRef } from "react";

function NavHighlightedMenuInner({ items, offset }) {
  const [activeId, setActiveId] = useState(null);
  const rootRef = useRef(null);

  const onScroll = () => {
    let isActiveFound = false;

    for (let i = 0; i < items.length; i++) {
      const item = items[i];

      const node = document.querySelector(`[data-nav-section="${item.anchor}"]`);
      if (!node || typeof node.getBoundingClientRect !== "function") continue;

      const boundingClientRect = node.getBoundingClientRect();

      if (
        boundingClientRect.top < window.innerHeight &&
        boundingClientRect.top - offset - 20 + node.offsetHeight > 0
      ) {
        if (activeId !== item.anchor) {
          onChangeActiveItem(item.anchor);
        }

        isActiveFound = true;
        break;
      }
    }

    if (!isActiveFound) {
      setActiveId(null);
    }
  };

  const onChangeActiveItem = (id) => {
    setActiveId(id);
  
    if (id) {
      setTimeout(() => {
        const activeNode = rootRef.current?.querySelector(".nav__item_active");
        if (activeNode) {
          // Use standard scrollIntoView method with smooth behavior
          activeNode.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'nearest', 
            inline: 'start' 
          });
        }
      });
    }
  };

  useEffect(() => {
    onScroll();
    window.addEventListener("scroll", onScroll);

    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, [items, offset]);

  return (
    <div className="nav" ref={rootRef}>
      <div className="nav__inner">
        {items.map((item) => (
          <li
            key={item.anchor}
            className={`nav__item nav__item_${activeId === item.anchor ? "active" : "no-active"}`}
          >
            <a
              href={`#${item.anchor}`}
              className={`nav__link nav__link_${activeId === item.anchor ? "active" : "no-active"}`}
            >
              {item.content.toUpperCase()}
            </a>
          </li>
        ))}
      </div>
    </div>
  );
}

export function NavHighlightedMenu({ items, offset }) {
  if (!items || !(items instanceof Array) || items.length === 0) return null;

  return <NavHighlightedMenuInner items={items} offset={offset} />;
}
